import React from "react";
import styled from "styled-components";
import colors from "../../assets/colors";
import { mobileScreen } from "../../assets/screens";

// eslint-disable-next-line import/no-anonymous-default-export
export default function ({ percent, isClaims, headerSubtext, headerText }) {
  return (
    <Header>
      <HeaderText className="fs-1">{headerText}</HeaderText>

      
      {!isClaims && <ProgressMobile percent={percent} />}

      <h5 style={{ margin: "15px 0", padding: "0 10px", color: "#a2a2a2" }}>
        {headerSubtext}
      </h5>
    </Header>
  );
}

const HeaderText = styled("h5")`
  color: ${colors.black};
`;

const Header = styled("div")`
  text-align: center;
  padding-bottom: 5px;
  margin-top: 20px;
  padding: 0 2px;
`;

const ProgressMobile = styled("div")`
  background-color: #00bdc224;
  width: 100%;
  height: 18px;
  ${mobileScreen(`
  display: block;
  `)}
  display: none;
  position: relative;
  margin: 15px 0;
  border-radius: 4px;
  overflow: hidden;
  color: ${(props) => (props.percent >= 50 ? "white" : "black")};

  &:after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    background-color: ${colors.blue3};
    height: 100%;
    width: ${(props) => (props.percent ? props.percent : 0)}%;
    transition: width 0.4s ease;
  }

  &:before {
    content: "${(props) => (props.percent ? props.percent : 0)}%";
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 100;
    font-size: 12px;
    font-weight: 500;
  }
`;
